import React from 'react';
import { Box, Link } from '@mui/material';

interface SkipNavigationProps {
  mainContentId?: string;
  navigationId?: string;
}

/**
 * WCAG 2.4.1 - Skip Navigation Links
 * Provides keyboard users a way to bypass repetitive navigation content
 */
const SkipNavigation: React.FC<SkipNavigationProps> = ({
  mainContentId = 'main-content',
  navigationId = 'main-navigation',
}) => {
  return (
    <Box
      component="nav"
      role="navigation"
      aria-label="Skip navigation"
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 9999,
        // Hide by default, show on focus
        '& a': {
          position: 'absolute',
          left: '-10000px',
          top: 'auto',
          width: '1px',
          height: '1px',
          overflow: 'hidden',
          // Show when focused
          '&:focus': {
            position: 'static',
            left: 'auto',
            top: 'auto',
            width: 'auto',
            height: 'auto',
            overflow: 'visible',
            display: 'block',
            padding: '8px 16px',
            backgroundColor: 'primary.main',
            color: 'primary.contrastText',
            textDecoration: 'none',
            fontWeight: 'bold',
            borderRadius: '0 0 4px 4px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
            outline: '3px solid #005FCC',
            outlineOffset: '2px',
          },
        },
      }}
    >
      <Link
        href={`#${mainContentId}`}
        sx={{
          '&:focus': {
            textDecoration: 'none !important',
          },
        }}
      >
        Skip to main content
      </Link>
      <Link
        href={`#${navigationId}`}
        sx={{
          '&:focus': {
            textDecoration: 'none !important',
          },
        }}
      >
        Skip to navigation
      </Link>
    </Box>
  );
};

export default SkipNavigation;
